import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Interest form for either live offer. Collects name, email, phone, an optional
 * "how did you hear" answer and (single journey) a preferred date. No health
 * data. Never opens checkout.
 */
export default function RequestForm({ title, note, arm = '', offer = 'four-week', dates = [], id = 'request', submitLabel = 'Request your spot' }) {
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: '', email: '', phone: '', heard_from: '', preferred_date: '' });
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');
  const tid = offer === 'four-week' ? 'request' : 'single';

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (dates.length && !form.preferred_date) {
      setError('Please choose a session date.');
      return;
    }
    setStatus('sending');
    setError('');
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/requests`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, offer, page: window.location.pathname, arm }),
      });
      if (!res.ok) throw new Error('Please check your details and try again.');
      const data = await res.json().catch(() => ({}));
      navigate(`/thank-you?offer=${offer}`, {
        state: { preferredDate: form.preferred_date || '', confirmed: data.confirmation_sent !== false },
      });
    } catch (err) {
      setStatus('idle');
      setError(err.message || 'Something went wrong. Please try again.');
    }
  };

  return (
    <form className="req-form" id={id} onSubmit={submit} data-testid={`${tid}-form`} noValidate>
      <h3 className="req-title">{title}</h3>
      {note && <p className="req-note">{note}</p>}
      <label>
        <span>Full name</span>
        <input data-testid={`${tid}-name`} type="text" required minLength={2} autoComplete="name" value={form.full_name} onChange={set('full_name')} />
      </label>
      <label>
        <span>Email address</span>
        <input data-testid={`${tid}-email`} type="email" required autoComplete="email" value={form.email} onChange={set('email')} />
      </label>
      <label>
        <span>Phone number</span>
        <input data-testid={`${tid}-phone`} type="tel" required minLength={7} autoComplete="tel" value={form.phone} onChange={set('phone')} />
      </label>
      {dates.length > 0 && (
        <label>
          <span>Preferred session date</span>
          <select data-testid={`${tid}-date`} required value={form.preferred_date} onChange={set('preferred_date')}>
            <option value="">Choose a date…</option>
            {dates.map((d) => <option key={d} value={d}>{d}</option>)}
          </select>
        </label>
      )}
      <label>
        <span>How did you hear about The Performance Reset? <em>(optional)</em></span>
        <input data-testid={`${tid}-heard`} type="text" maxLength={300} value={form.heard_from} onChange={set('heard_from')} />
      </label>
      {error && <p className="req-error" role="alert" data-testid={`${tid}-error`}>{error}</p>}
      <div className="cta-wrap">
        <button className="cta" type="submit" disabled={status === 'sending'} data-testid={`${tid}-submit`}>
          {status === 'sending' ? 'Sending…' : submitLabel} <span aria-hidden="true">→</span>
        </button>
        <p className="cta-note">This is not a purchase. Health screening happens privately afterwards, and payment only once Karla confirms your place.</p>
      </div>
    </form>
  );
}
